import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { CoreParkLogo } from '@logos/corepark'

@Component({
	selector: 'validation-layout',
	template: `
		<header>
			<corepark-logo colorFill="var(--color-white)" />
			<h1>Ticket Validation</h1>
		</header>
		<section>
			<router-outlet />
		</section>
	`,
	styleUrl: './validation-layout.component.scss',
	imports: [RouterOutlet, CoreParkLogo],
})
export class ValidationLayoutComponent {}
